module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "userReadOnly": {
        "type": "boolean",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "subscreenView": {
    "name": "interaction",
    "class": "view",
    "properties": {
      "subscreen": "string",
      "userReadOnly": {
        "type": "boolean",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "navigateToOutdatedRestorePage": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "interactWithCustomCodeSecrets": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "interactionType": {
        "type": [
          "update",
          "add",
          "delete"
        ]
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickSecretsManagement": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "interactWithGoToAction": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "application_id": {
        "type": "string",
        "isOptional": true
      },
      "includes_at_mentions": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "new_actions": {
        "type": "string",
        "isOptional": true
      },
      "runtime": {
        "type": "string",
        "isOptional": true
      },
      "numberOfInputs": {
        "type": "number",
        "isOptional": true
      },
      "action": "string",
      "interactionType": {
        "type": [
          "change",
          "delete",
          "cancel (canvas)",
          "cancel (editor)",
          "save",
          "create"
        ]
      },
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "newWorkflow": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "firstNewWorkflow": {
    "name": "first new workflow",
    "class": "activation",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "createdWorkflow": {
    "name": "create workflow",
    "class": "creation",
    "properties": {
      "action": "string",
      "name": "string",
      "type": "string",
      "trigger": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "createdEmbeddedWorkflow": {
    "name": "create workflow",
    "class": "creation",
    "properties": {
      "action": "string",
      "id": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "flowObjectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "sourceAppId": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "createdWorkflowFromTemplate": {
    "name": "create workflow",
    "class": "creation",
    "properties": {
      "action": "string",
      "name": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "templateId": "number",
      "flowId": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editEnrollment": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "shouldReenroll": {
        "type": "boolean",
        "isOptional": true
      },
      "setupType": {
        "type": "string",
        "isOptional": true
      },
      "isEmpty": {
        "type": "boolean",
        "isOptional": true
      },
      "templateId": {
        "type": "number",
        "isOptional": true
      },
      "properties": {
        "type": "array",
        "isOptional": true
      },
      "operators": {
        "type": "array",
        "isOptional": true
      },
      "filterType": {
        "type": "array",
        "isOptional": true
      },
      "associatedObjectTypeIds": {
        "type": "array",
        "isOptional": true
      },
      "reenrollmentProperties": {
        "type": "array",
        "isOptional": true
      },
      "reenrollmentOperators": {
        "type": "array",
        "isOptional": true
      },
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "eventType": {
        "type": "array",
        "isOptional": true
      },
      "enrollmentType": {
        "type": [
          "LIST",
          "EVENT",
          "SCHEDULED"
        ],
        "isOptional": true
      },
      "frequency": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editEventTrigger": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "editType": [
        "ADD",
        "DELETE"
      ],
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggleEventTriggersBeta": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "toggleType": [
        "OPT-IN",
        "OPT-OUT"
      ],
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editRefinementCriteria": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "editType": [
        "EDIT",
        "SAVE"
      ],
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editEnrollmentOfEmbeddedFlow": {
    "name": "edit enrollment",
    "class": "usage",
    "properties": {
      "action": "string",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "contactCalculation": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "calculationTime": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedContactCalculationListsLink": {
    "name": "edit enrollment",
    "class": "usage",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggleReenrollment": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "enabled": "boolean",
      "enrollmentType": [
        "LIST",
        "EVENT"
      ],
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggleReenrollmentFilter": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "enabled": {
        "type": "boolean"
      },
      "flowObjectType": {
        "type": "string",
        "isOptional": true
      },
      "objectTypeId": {
        "type": "string"
      },
      "property": {
        "type": "string"
      },
      "operation": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggleEnrollmentType": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "enrollExistingContacts": {
    "name": "edit enrollment",
    "class": "interaction",
    "properties": {
      "action": "string",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "existing": {
        "type": "boolean",
        "isOptional": true
      },
      "succeeded": {
        "type": "boolean",
        "isOptional": true
      },
      "selectedOption": {
        "type": [
          "INDIVIDUAL",
          "LIST",
          "CUSTOM",
          "TRIGGERS"
        ],
        "isOptional": true
      },
      "enrollLocation": {
        "type": [
          "NAVIGATION_TABS",
          "ENROLL_EXISTING",
          "FLOW_DETAILS"
        ],
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "deleteWorkflowClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "deleteWorfklow": {
    "name": "delete workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "activateWorkflow": {
    "name": "activate workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "numberOfActions": {
        "type": "number",
        "isOptional": true
      },
      "templateId": {
        "type": "number",
        "isOptional": true
      },
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "existing": {
        "type": "boolean",
        "isOptional": true
      },
      "origin": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "activateWorkflowFromEmbed": {
    "name": "activate workflow",
    "class": "usage",
    "properties": {
      "action": "string",
      "sourceApp": {
        "type": "string"
      },
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "actionTypeCountOnEnable": {
    "name": "activate workflow",
    "class": "usage",
    "properties": {
      "action": "string",
      "actionType": "string",
      "count": {
        "type": "number",
        "isOptional": false
      },
      "numberOfActions": {
        "type": "number",
        "isOptional": true
      },
      "templateId": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickReviewEdit": {
    "name": "activate workflow",
    "class": "interaction",
    "properties": {
      "enroll_existing": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "reviewSection": "string",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "moveWorkflowClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "moveWorkflow": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "bulkMoveWorkflowClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "bulkMoveWorkflow": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "count": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "createFolderClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "createFolder": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "renameFolderClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "renameFolder": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "deleteFolderClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "deleteFolder": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "deleteFolderAfterReference": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "forceDeleted": "boolean",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "assignTeamClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "assignedTeam": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "teamCount": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "bulkAssignTeamClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "bulkAssignTeam": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "filterRequest": "boolean",
      "count": "number",
      "subscreen": "string",
      "teamCount": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "bulkDeleteClick": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "bulkDelete": {
    "name": "manage workflows",
    "class": "usage",
    "properties": {
      "action": "string",
      "filterRequest": "boolean",
      "count": "number",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changeIndexTab": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "destinationTab": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "embeddedAppLoaded": {
    "name": "evaluate workflow performance",
    "class": "interaction",
    "properties": {
      "action": "string",
      "time": "number",
      "timeout": "boolean",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "evaluateWorkflowPerformance": {
    "name": "evaluate workflow performance",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changeWorkflowHistoryTypeFilter": {
    "name": "evaluate workflow performance",
    "class": "interaction",
    "properties": {
      "action": "string",
      "eventType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changeWorkflowPerfTimeFilter": {
    "name": "evaluate workflow performance",
    "class": "interaction",
    "properties": {
      "action": "string",
      "timeRange": "string",
      "chartKey": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changeWorkflowsFilter": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "sortWorkflowsTableColumn": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "sortField": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "loadMoreHistory": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changeHistoryFilters": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "filterValue": {
        "type": "string",
        "isOptional": true
      },
      "startDate": {
        "type": "string",
        "isOptional": true
      },
      "endDate": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "retryHistory": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "unenrollModal": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editWorkflowProperties": {
    "name": "edit workflow properties",
    "class": "interaction",
    "properties": {
      "action": "string",
      "quickOptionDays": {
        "type": "array",
        "isOptional": true
      },
      "customDate": {
        "type": "boolean",
        "isOptional": true
      },
      "recurringDate": {
        "type": "boolean",
        "isOptional": true
      },
      "description": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "wasGeneratedDescriptionCustomized": {
        "type": "string",
        "isOptional": true
      },
      "withGeneratedDescription": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "generateWorkflowDescription": {
    "name": "edit workflow properties",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "description": {
        "type": "string",
        "isOptional": true
      },
      "rating": {
        "type": "string",
        "isOptional": true
      },
      "feedback": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "generateWorkflowName": {
    "name": "edit workflow properties",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editWorkflowSetting": {
    "name": "edit workflow properties",
    "class": "interaction",
    "properties": {
      "action": "string",
      "setting": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "addProperties": {
    "name": "edit workflow properties",
    "class": "interaction",
    "properties": {
      "action": "string",
      "missingPropertyIds": {
        "type": "array",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "testWorkflow": {
    "name": "test workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickTestFlow": {
    "name": "test workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "id": "number",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "enrollTestObject": {
    "name": "test workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "id": "number",
      "objectId": "number",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedAlerts": {
    "name": "view alerts",
    "class": "interaction",
    "properties": {
      "action_id": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "expanded": "boolean",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedAlert": {
    "name": "view alerts",
    "class": "interaction",
    "properties": {
      "action": "string",
      "alertType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedActionConfigAlert": {
    "name": "view alerts",
    "class": "interaction",
    "properties": {
      "action": "string",
      "alertType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editActions": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "application_id": {
        "type": "string",
        "isOptional": true
      },
      "includes_at_mentions": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "new_actions": {
        "type": "string",
        "isOptional": true
      },
      "runtime": {
        "type": "string",
        "isOptional": true
      },
      "numberOfInputs": {
        "type": "number",
        "isOptional": true
      },
      "action": "string",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "allItems": {
        "type": "boolean",
        "isOptional": true
      },
      "noteType": {
        "type": "string",
        "isOptional": true
      },
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "includeAtMentions": {
        "type": "string",
        "isOptional": true
      },
      "otherAction": {
        "type": "string",
        "isOptional": true
      },
      "actionType": {
        "type": "string",
        "isOptional": true
      },
      "flowType": {
        "type": [
          "Workflow",
          "ActionSet"
        ],
        "isOptional": true
      },
      "actionTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editActionWithSpecifics": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "application_id": {
        "type": "string",
        "isOptional": true
      },
      "includes_at_mentions": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "new_actions": {
        "type": "string",
        "isOptional": true
      },
      "runtime": {
        "type": "string",
        "isOptional": true
      },
      "numberOfInputs": {
        "type": "number",
        "isOptional": true
      },
      "action": "string",
      "actionType": "string",
      "isNewAction": "boolean",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "continueIfEventOccurred": {
        "type": "boolean",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editPlatformActionWithSpecifics": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "application_id": {
        "type": "string",
        "isOptional": true
      },
      "includes_at_mentions": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "new_actions": {
        "type": "string",
        "isOptional": true
      },
      "runtime": {
        "type": "string",
        "isOptional": true
      },
      "numberOfInputs": {
        "type": "number",
        "isOptional": true
      },
      "action": "string",
      "actionId": "number",
      "actionType": "string",
      "actionTypeId": {
        "type": "string",
        "isOptional": true
      },
      "groupId": {
        "type": "string",
        "isOptional": true
      },
      "isCustomFormula": {
        "type": "boolean",
        "isOptional": true
      },
      "customFormulaOperators": {
        "type": "array",
        "isOptional": true
      },
      "customFormulaExpressions": {
        "type": "array",
        "isOptional": true
      },
      "delta": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionAppId": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionAppName": {
        "type": "string",
        "isOptional": true
      },
      "extensionDefinitionId": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionName": {
        "type": "string",
        "isOptional": true
      },
      "formatter": {
        "type": "string",
        "isOptional": true
      },
      "inputType": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": "boolean",
      "isNewAction": "boolean",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "property": {
        "type": "string",
        "isOptional": true
      },
      "sourceAction": {
        "type": "string",
        "isOptional": true
      },
      "sourceApp": "string",
      "userReadOnly": {
        "type": "boolean",
        "isOptional": true
      },
      "toObjectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "emailSubcategory": {
        "type": "string",
        "isOptional": true
      },
      "emailType": {
        "type": "string",
        "isOptional": true
      },
      "numberOfBranches": {
        "type": "string",
        "isOptional": true
      },
      "syncEnabled": {
        "type": "string",
        "isOptional": true
      },
      "expirationTime": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "daysOfWeek": {
        "type": "string",
        "isOptional": true
      },
      "sourceType": {
        "type": "string",
        "isOptional": true
      },
      "objectTypeIdSelected": {
        "type": "string",
        "isOptional": true
      },
      "eventName": {
        "type": "string",
        "isOptional": true
      },
      "timeZone": {
        "type": "string",
        "isOptional": true
      },
      "timeOfDay": {
        "type": "string",
        "isOptional": true
      },
      "numLineItems": {
        "type": "number",
        "isOptional": true
      },
      "formulaOperators": {
        "type": "string",
        "isOptional": true
      },
      "flowType": {
        "type": [
          "Workflow",
          "ActionSet"
        ],
        "isOptional": true
      },
      "customFieldCount": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "manageWorkflows": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewDoc": {
    "name": "view documentation",
    "class": "interaction",
    "properties": {
      "action": "string",
      "document": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openWorkflowsAppFromEmbed": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "sourceApp": "string",
      "type": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "numberOfActions": {
        "type": "number",
        "isOptional": true
      },
      "numberOfProperties": {
        "type": "number",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedEmailFromEditor": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "isNewEmail": "boolean",
      "isEmbedded": "boolean",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedOptimization": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "conversions": "number",
      "collapsed": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "deletedEmailFromEditor": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "isEmbedded": "boolean",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedTemplateWorkflowOption": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "templateId": "number",
      "isEmbedded": "boolean",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedParameterizedTemplateOption": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "templateId": "number",
      "seachQueryApplied": "boolean",
      "categoryFilter": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "choseParameterizedTemplateOption": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "templateId": "number",
      "seachQueryApplied": {
        "type": "boolean",
        "isOptional": true
      },
      "categoryFilter": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "modifiedTemplateFilter": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "templateId": "number",
      "seachQueryApplied": "boolean",
      "categoryFilter": "string",
      "filterModified": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "renderedIllustrationEmptyState": {
    "name": "manage workflows",
    "class": "view",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "renderedTemplatesOnboarding": {
    "name": "create workflow",
    "class": "view",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "count": {
        "type": "number",
        "isOptional": false
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedCreateWorkflowNavigationTab": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "tabName": "string",
      "isEmbedded": "boolean",
      "sourceApp": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedStartFromScratch": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "stepParameterizedTemplate": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "templateId": "number",
      "stepIndex": "number",
      "stepDirection": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "completedParameterizedTemplate": {
    "name": "create workflow",
    "class": "usage",
    "properties": {
      "action": "string",
      "subaction": "string",
      "templateId": "number",
      "stepIndex": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "canceledParameterizedTemplate": {
    "name": "create workflow",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "changesMade": "boolean",
      "templateId": "number",
      "stepIndex": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedEmailFieldNewEmailLink": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subaction": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedEventDetailsPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedEnrollmentDetailsPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggleEnrollmentDetailsPanelSection": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "toggleType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedRevisionsPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickMismatchedValuesSubpage": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "exportWorkflows": {
    "name": "interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedBranchAction": {
    "name": "interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "actionId": "number",
      "isNewAction": "boolean",
      "numberOfBranches": "number",
      "defaultBranchNameChanged": "boolean",
      "listBranchNameChanged": "boolean",
      "properties": {
        "type": "array",
        "isOptional": true
      },
      "operators": {
        "type": "array",
        "isOptional": true
      },
      "filterType": {
        "type": "array",
        "isOptional": true
      },
      "associatedObjectTypeIds": {
        "type": "array",
        "isOptional": true
      },
      "length": {
        "type": "array",
        "isOptional": true
      },
      "flowType": {
        "type": [
          "Workflow",
          "ActionSet"
        ],
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedStaticBranchAction": {
    "name": "interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "actionId": "number",
      "inputType": "string",
      "isNewAction": "boolean",
      "numberOfBranches": "number",
      "property": "string",
      "sourceAction": {
        "type": "string",
        "isOptional": true
      },
      "flowType": {
        "type": [
          "Workflow",
          "ActionSet"
        ],
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "loadIndexListingPage": {
    "name": "manage workflows",
    "class": "view",
    "properties": {
      "action": "string",
      "workflowCount": "number",
      "folderCount": "number",
      "count": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "loadContactWorkflowContainer": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": "string",
      "isEnabled": "boolean",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "loadPlatformWorkflowContainer": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionCount": "number",
      "subscreen": {
        "type": "string"
      },
      "size": {
        "type": "number"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickCreateNewPropertyLink": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionType": "string",
      "objectType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickToggleMinimap": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "interactionType": {
        "type": [
          "panel open",
          "panel close"
        ]
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedActionCardOption": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "tourStart": {
    "name": "interaction",
    "class": "view",
    "properties": {
      "action": "string",
      "tour": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "tourSkip": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "tour": "string",
      "step": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "tourNext": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "tour": "string",
      "step": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "tourComplete": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "tour": "string",
      "step": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "endOnboardingTour": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionType": "string",
      "step": {
        "type": "number"
      },
      "isCompleted": {
        "type": "boolean"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "retryFailedReferences": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickFlowDetailsButton": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedFlowDetailsPanel": {
    "name": "manage workflows",
    "class": "view",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedReferenceType": {
    "name": "manage workflows",
    "class": "view",
    "properties": {
      "action": "string",
      "assetType": "string",
      "referenceType": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedRelaxedValidationAlertsRollup": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "errorCount": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedRelaxedValidationError": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionId": "number",
      "actionType": "string",
      "errorCount": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedRelaxedValidationReviewButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "tab": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedRelaxedValidationResolutionPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedRelaxedValidationResolutionPanelTemplateDescription": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "templateId": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedRelaxedValidationAction": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionId": "number",
      "actionType": "string",
      "actionTypeId": {
        "type": "string",
        "isOptional": true
      },
      "extensionDefinitionAppId": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionAppName": {
        "type": "string",
        "isOptional": true
      },
      "extensionDefinitionId": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionName": {
        "type": "string",
        "isOptional": true
      },
      "groupId": {
        "type": "string",
        "isOptional": true
      },
      "isNewAction": "boolean",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "sourceApp": "string",
      "toObjectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "emailSubcategory": {
        "type": "string",
        "isOptional": true
      },
      "emailType": {
        "type": "string",
        "isOptional": true
      },
      "numberOfBranches": {
        "type": "string",
        "isOptional": true
      },
      "syncEnabled": {
        "type": "string",
        "isOptional": true
      },
      "expirationTime": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "sourceType": {
        "type": "string",
        "isOptional": true
      },
      "objectTypeIdSelected": {
        "type": "string",
        "isOptional": true
      },
      "eventName": {
        "type": "string",
        "isOptional": true
      },
      "numLineItems": {
        "type": "number",
        "isOptional": true
      },
      "flowType": {
        "type": [
          "Workflow",
          "ActionSet"
        ],
        "isOptional": true
      },
      "customFieldCount": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "completedRelaxedValidationResolutionPanel": {
    "name": "interaction",
    "class": "view",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedRelaxedValidationResolutionPanelReviewButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedContextualEmbedAction": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionId": "number",
      "actionType": "string",
      "actionTypeId": {
        "type": "string",
        "isOptional": true
      },
      "extensionDefinitionAppId": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionAppName": {
        "type": "string",
        "isOptional": true
      },
      "extensionDefinitionId": {
        "type": "number",
        "isOptional": true
      },
      "extensionDefinitionName": {
        "type": "string",
        "isOptional": true
      },
      "groupId": {
        "type": "string",
        "isOptional": true
      },
      "isNewAction": "boolean",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "sourceApp": "string",
      "emailSubcategory": {
        "type": "string",
        "isOptional": true
      },
      "emailType": {
        "type": "string",
        "isOptional": true
      },
      "syncEnabled": {
        "type": "string",
        "isOptional": true
      },
      "daysOfWeek": {
        "type": "string",
        "isOptional": true
      },
      "objectTypeIdSelected": {
        "type": "string",
        "isOptional": true
      },
      "timeZone": {
        "type": "string",
        "isOptional": true
      },
      "timeOfDay": {
        "type": "string",
        "isOptional": true
      },
      "flowType": {
        "type": [
          "Workflow",
          "ActionSet"
        ],
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "navigateToWorkflowsAppFromContextualEmbed": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "sourceApp": "string",
      "type": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedBackToWorkflows": {
    "name": "manage workflows",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickViewEnrollments": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickViewNewEnrollments": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openMoreDropdown": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewEditorWithEnrollmentHistoryPanel": {
    "name": "interaction",
    "class": "view",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedLinkToActionLogs": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionTypeId": {
        "type": "string"
      },
      "errorType": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "editNotificationSettings": {
    "name": "interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "hasIncreaseThresholdSet": {
        "type": "boolean"
      },
      "hasDecreaseThresholdSet": {
        "type": "boolean"
      },
      "hasUsersSet": {
        "type": "boolean"
      },
      "hasTeamsSet": {
        "type": "boolean"
      },
      "notificationCadence": {
        "type": [
          "WEEKLY",
          "DAILY"
        ],
        "isOptional": true
      },
      "type": {
        "type": "array"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedViewWorkflowRevision": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggledOperationsHubOnboarding": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "isEnabled": {
        "type": "boolean"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedOperationsHubOnboardingPage": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "page": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedDataPassingPanel": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "action": "string",
      "source": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedAddDataSource": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedDataPanelDataSource": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "source": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickDataPassingPanelDataSource": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "source": {
        "type": "string"
      },
      "flowObjectTypeId": {
        "type": "string"
      },
      "objectTypeIdSelected": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "searchDataPanelProperties": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "search": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickDataPassingPanelCollapse": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickDataPassingPanelPropertyInfo": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "modal": "string",
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedADataSourceToWorkflow": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "flowObjectTypeId": {
        "type": "string"
      },
      "objectTypeIdSelected": {
        "type": "string",
        "isOptional": true
      },
      "category": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedFormulaPreviewSampleData": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "page": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "closedTriggerSelectionOnboardingTour": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "completedTriggerSelectionOnboardingTour": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedTriggerSelectionPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedChangeTriggerTypeButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "enrollmentType": [
        "LIST",
        "EVENT",
        "SCHEDULE"
      ],
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "webhookTriggerInteraction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionType": {
        "type": [
          "OPENED_INFO_MODAL"
        ],
        "isOptional": true
      },
      "step": {
        "type": [
          "NAME",
          "CONNECT",
          "MAP",
          "MATCH"
        ],
        "isOptional": true
      },
      "editType": {
        "type": [
          "CREATE",
          "EDIT",
          "DELETE",
          "CREATE_CONFIRM",
          "EDIT_CONFIRM",
          "DELETE_CONFIRM"
        ],
        "isOptional": true
      },
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedUndoWorkflowButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedRedoWorkflowButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedActionDetailsButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "actionType": "string",
      "interaction": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedCreateActionSet": {
    "name": "create workflow",
    "class": "creation",
    "properties": {
      "action": "string",
      "type": {
        "type": [
          "workflow",
          "actionSet"
        ]
      },
      "flowObjectTypeId": "string",
      "description": {
        "type": "boolean"
      },
      "existing": {
        "type": "boolean"
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedDeleteActionSet": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedEditActionSet": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedInsertActionSet": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "numberOfActions": {
        "type": "number",
        "isOptional": true
      },
      "actionSetId": "number",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedCreateActionSetModal": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "savedAndExitedActionSet": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "flowObjectTypeId": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "numberOfActions": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "interactedWithNonEnrollmentDiagnosis": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "flowObjectTypeId": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "renderLogEvent": {
    "name": "manage workflows",
    "class": "view",
    "properties": {
      "action": "string",
      "objectTypeId": "string",
      "eventId": "string",
      "path": {
        "type": "string",
        "isOptional": true
      },
      "numRows": {
        "type": "number"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "renderedEmptySearchResultsInPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "mode": {
        "type": [
          "all-actions",
          "connect-app"
        ]
      },
      "search": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedActionInPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "mode": {
        "type": [
          "all-actions",
          "connect-app"
        ]
      },
      "search": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openAiPromptExamples": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "assetType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "copyAiExamplePrompt": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "exampleAiPrompt": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickToGenerateAsset": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "aiPrompt": "string",
      "assetType": "string",
      "destination": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickToAddFilterToPrompt": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "mode": {
        "type": "string"
      },
      "type": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickToRemoveFilterFromPrompt": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "mode": {
        "type": "string"
      },
      "type": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "insertGeneratedAsset": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "aiPrompt": "string",
      "assetType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "discardGeneratedAsset": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "aiPrompt": "string",
      "assetType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "rateGeneratedAsset": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "aiPrompt": "string",
      "assetType": "string",
      "feedback": {
        "isOptional": true,
        "type": "string"
      },
      "flowId": {
        "isOptional": true,
        "type": "number"
      },
      "generationResponse": "string",
      "rating": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedZoomButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "destination": {
        "type": "string"
      },
      "size": {
        "type": "number"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "selectedMenuBarOption": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "interactionType": [
        "shortcut",
        "menu"
      ],
      "mode": [
        "editor",
        "revision",
        "performance-history",
        "flow-view"
      ],
      "value": "string",
      "type": [
        "dropdown",
        "quick-option"
      ],
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "viewedPropertyTriggerSelectionPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "selectedPropertyTrigger": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": [
        "object-agnostic",
        "object-specific"
      ],
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedMarketplaceAppLink": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": "string",
      "applicationId": {
        "type": "number"
      },
      "itemIndex": {
        "type": "number"
      },
      "totalResults": {
        "type": "number"
      },
      "isRecommended": {
        "type": "boolean"
      },
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggledAppActionCategoryAccordion": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": [
        "toggled app action category accordion"
      ],
      "subAction": [
        "opened app action category accordion",
        "closed app action category accordion"
      ],
      "applicationId": {
        "type": "number"
      },
      "itemIndex": {
        "type": "number"
      },
      "totalResults": {
        "type": "number"
      },
      "isRecommended": {
        "type": "boolean"
      },
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "sortedMarketplaceApps": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": [
        "sorted marketplace apps"
      ],
      "sortField": "string",
      "sortOrder": "string",
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedLoadMoreMarketplaceApps": {
    "name": "edit actions",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked to load more marketplace apps"
      ],
      "totalResults": "number",
      "objectTypeId": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedViewEnrollmentButton": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changePerformanceHistoryFilters": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "objectId": {
        "type": "string",
        "isOptional": true
      },
      "startDate": {
        "type": "string",
        "isOptional": true
      },
      "endDate": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedChangeEnrollment": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedLinkOnPerformanceHistoryPage": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "toggleLogEventSection": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "toggleType": "string",
      "logEventType": "string",
      "actionType": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "closeModeIndicator": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "changedEnrollmentUsingSelectField": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedViewInCrmLink": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedPerformanceHistoryWorkflowNode": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subscreen": "string",
      "logEventType": {
        "type": "string",
        "isOptional": true
      },
      "actionType": {
        "type": "string",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedDiagnoseEnrollmentPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "openedDiagnoseBranchPanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "AggregatePerformanceCloseModeIndicator": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedActionCardOnAggregatePerformancePage": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedAggregatePerformanceTrackingToggle": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedMatchingEnrollmentsOnAggregatePerformancePanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedViewEnrollmentHistoryOnAggregatePerformancePanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedExpandCollapseSectionOnAggregatePerformancePanel": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "toggleType": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "resetAggregatePerformanceFilters": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickGenerateTextForInput": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickGenerateTextForInputPrompt": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "source": {
        "type": "string"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickRegenerateTextForInput": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "addRecommendedActionShown": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "source": {
        "type": "array",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "addRecommendedActionClicked": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "actionTypeId": {
        "type": "string"
      },
      "source": {
        "type": "array",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "dismissRecommendedActionClicked": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "actionTypeId": {
        "type": "string"
      },
      "source": {
        "type": "array",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "workflows"
  },
  "clickedAddDatasetTrigger": {
    "namespace": "data-studio",
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "assetType": {
        "type": "string"
      },
      "assetId": {
        "type": "number",
        "isOptional": true
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "savedDatasetTrigger": {
    "namespace": "data-studio",
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "assetType": {
        "type": "string"
      },
      "assetId": {
        "type": "number"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "activatedDatasetWorkflow": {
    "namespace": "data-studio",
    "name": "usage",
    "class": "usage",
    "properties": {
      "assetType": {
        "type": "string"
      },
      "assetId": {
        "type": "number"
      },
      "immediate": {
        "type": "string",
        "isOptional": true
      },
      "flowId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "inlineEditInteraction": {
    "name": "inline edit interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "text-selected",
          "menu-open",
          "menu-selection",
          "tiny-mce-toolbar-menu-selection",
          "tone-selection",
          "click-generate",
          "click-try-again",
          "preview-window-rewrite",
          "insert-content",
          "preview-window-close",
          "preview-window-previous",
          "preview-window-next",
          "click-settings-link"
        ]
      },
      "actionType": {
        "type": [
          "slash-command",
          "selection-command"
        ]
      },
      "selected": {
        "isOptional": true,
        "type": "string"
      },
      "choice": {
        "isOptional": true,
        "type": [
          "friendly",
          "professional",
          "witty",
          "heartfelt",
          "educational"
        ]
      },
      "command": {
        "type": "string",
        "isOptional": true
      },
      "text": {
        "type": "string",
        "isOptional": true
      },
      "result": {
        "type": "string",
        "isOptional": true
      },
      "usageDescription": {
        "type": "string",
        "isOptional": true
      },
      "inline": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "regenerateClickCount": {
        "type": "number",
        "isOptional": true
      },
      "usingBrandVoice": {
        "type": "boolean",
        "isOptional": true
      },
      "userEditedResult": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "content-assistance-lib"
  },
  "contentGenerationModalInteraction": {
    "name": "content generation modal interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "open-modal",
          "close-modal",
          "click-generate",
          "click-generate-more",
          "click-trigger-button",
          "fetch-results",
          "choose-result",
          "video-started",
          "video-completed",
          "turn-on-content-assistant",
          "click-maybe-later",
          "click-settings-link",
          "click-go-back"
        ]
      },
      "usageDescription": {
        "type": "string"
      },
      "text": {
        "type": "string",
        "isOptional": true
      },
      "approximateTokenCount": {
        "type": "number",
        "isOptional": true
      },
      "results": {
        "type": "array",
        "isOptional": true
      },
      "completionTokens": {
        "type": "number",
        "isOptional": true
      },
      "promptTokens": {
        "type": "number",
        "isOptional": true
      },
      "result": {
        "type": "string",
        "isOptional": true
      },
      "videoId": {
        "type": "number",
        "isOptional": true
      },
      "command": {
        "type": "string",
        "isOptional": true
      },
      "choice": {
        "isOptional": true,
        "type": "string"
      },
      "regenerateClickCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "content-assistance-lib"
  },
  "aiButtonInteraction": {
    "name": "aiButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "featureId": {
        "type": "string",
        "isOptional": true
      },
      "featureCategoryId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copilotActionButtonInteraction": {
    "name": "copilotActionButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "prompt": {
        "type": "string",
        "isOptional": true
      },
      "hasPrefillValues": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copyMessageInteraction": {
    "name": "copyMessageInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_copied"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "feedbackInteraction": {
    "name": "inlineFeedbackInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_upvoted",
          "prompt_upvote_removed",
          "prompt_downvoted",
          "prompt_downvote_removed"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "tinymceEdit": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCommand": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "value": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymcePaste": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "file",
        "html",
        "plaintext",
        "unknown"
      ],
      "pasteSource": {
        "type": "string",
        "isOptional": true
      },
      "hasImages": {
        "type": "boolean",
        "isOptional": true
      },
      "overwriteExisting": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEvent": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditSourceCode": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceChangeColor": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceColorPopoverMode": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "mode": {
        "type": "string"
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceChangeColorPopover": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "mode": {
        "type": "string",
        "isOptional": true
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "format": {
        "type": "string",
        "isOptional": true
      },
      "had-existing-color": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCta": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "context": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceFormatting": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "isCustomFont": {
        "type": "boolean",
        "isOptional": true
      },
      "customFontType": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceLink": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "nofollow": {
        "type": "boolean",
        "isOptional": true
      },
      "sponsored": {
        "type": "boolean",
        "isOptional": true
      },
      "ugc": {
        "type": "boolean",
        "isOptional": true
      },
      "externalLink": {
        "type": "boolean",
        "isOptional": true
      },
      "isImage": {
        "type": "boolean",
        "isOptional": true
      },
      "isIcon": {
        "type": "boolean",
        "isOptional": true
      },
      "linkType": {
        "type": "string",
        "isOptional": true
      },
      "isValidLink": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceImage": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "replacedImgSrc": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceContentGeneration": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditImage": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "imgSrc": {
        "type": "string",
        "isOptional": true
      },
      "fileSource": {
        "type": [
          "AI_GENERATED",
          "CANVA",
          "SHUTTERSTOCK"
        ],
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEmbed": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertEmbed": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "service": {
        "type": "string",
        "isOptional": true
      },
      "tab": [
        "general",
        "embed",
        "paste"
      ],
      "hasDimensions": {
        "type": "boolean",
        "isOptional": true
      },
      "useIframeEmbeds": {
        "type": "boolean",
        "isOptional": true
      },
      "hasScripts": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditEmbed": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymcePersonalize": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "category": "string",
      "fqn": "string",
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertPersonalizationToken": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "tokenName": "string",
      "tokenCategory": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotDefined": {
        "type": "boolean",
        "isOptional": true
      },
      "defaultValueType": [
        "global",
        "local",
        "empty"
      ],
      "fieldType": {
        "type": "string"
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditPersonalizationToken": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "tokenName": "string",
      "tokenCategory": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotDefined": {
        "type": "boolean",
        "isOptional": true
      },
      "defaultValueType": [
        "global",
        "local",
        "empty"
      ],
      "fieldType": {
        "type": "string"
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertRssToken": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "tokenName": "string",
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceVideo": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "type": "string",
      "method": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertVideo": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "type": "string",
      "replaced": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditVideo": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertEmoji": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "insertCount": {
        "type": "number",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEmoji": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertSnippet": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceSnippet": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertTable": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "columns": {
        "type": "number",
        "isOptional": true
      },
      "rows": {
        "type": "number",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditTable": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "command": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceKeyboardEscape": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "format": "string",
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceAnchor": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "insertLocation": {
        "type": "string",
        "isOptional": true
      },
      "dragStage": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceVisualBlocks": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "active": "boolean",
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertCallout": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "type": {
        "type": "string"
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditCallout": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "editType": {
        "type": "string"
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCharmap": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceFindReplace": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditIcon": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "aspectChanged": {
        "type": "string",
        "isOptional": true
      },
      "position": {
        "type": "string",
        "isOptional": true
      },
      "color": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "purpose": {
        "type": "string",
        "isOptional": true
      },
      "size": {
        "type": "string",
        "isOptional": true
      },
      "title": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "setName": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertIcon": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "setName": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "breakpointName": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  }
};